import { Slide, SliderService } from 'api/slider';
import Slider from 'react-slick';

import { Box, SLIDER_SETTINGS } from 'common';
import { useEffect, useState } from 'react';

export const SliderComponent = () => {
    const settings = SLIDER_SETTINGS;

    const [slides, setSlides] = useState<Slide[]>([]);

    useEffect(() => {
        const fetchSlides = async () => {
            try {
                const sliderService = SliderService.getInstance();
                const response = await sliderService.findAll();
                const sortedSlides = response.data.sort((a: Slide, b: Slide) => b.id - a.id);
    
                setSlides(sortedSlides);
            } catch (error) {
                console.error('Ошибка при получении данных слайдера:', error);
            }
        };

        fetchSlides();
    }, []);

    return (
        <Box>
            <Slider {...settings}>
                {slides.map((slide) => (
                    <Box key={slide.id} padding={2} boxSizing="border-box">
                        <img
                            src={slide.photo}
                            alt={`Slide ${slide.id}`}
                            style={{ width: '100%', height: '250px', borderRadius: 12, objectFit: 'cover' }}
                        />
                    </Box>
                ))}
            </Slider>
        </Box>
    );
};
